"use strict";
var EmailTemplateBlockInput_1;
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const index_1 = require("../../../index");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
let EmailTemplateBlockInput = EmailTemplateBlockInput_1 = class EmailTemplateBlockInput {
    constructor() {
        this.usingRichContentEditor = false;
    }
};
tslib_1.__decorate([
    type_graphql_1.Field(() => type_graphql_1.ID, { nullable: true }),
    tslib_1.__metadata("design:type", Number)
], EmailTemplateBlockInput.prototype, "id", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => type_graphql_1.Float, { nullable: false }),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateBlockInput.prototype, "order", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    tslib_1.__metadata("design:type", String)
], EmailTemplateBlockInput.prototype, "name", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => type_graphql_1.ID, { nullable: true }),
    tslib_1.__metadata("design:type", Number)
], EmailTemplateBlockInput.prototype, "cloneOfId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [EmailTemplateBlockInput_1], { nullable: true }),
    tslib_1.__metadata("design:type", Array)
], EmailTemplateBlockInput.prototype, "childBlocks", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => type_graphql_1.ID, { nullable: true }),
    tslib_1.__metadata("design:type", Number)
], EmailTemplateBlockInput.prototype, "repeatOfId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => type_graphql_1.ID, { nullable: true }),
    tslib_1.__metadata("design:type", Number)
], EmailTemplateBlockInput.prototype, "parentBlockId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateBlockInput.prototype, "clientId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => type_graphql_1.ID, { nullable: true }),
    tslib_1.__metadata("design:type", Number)
], EmailTemplateBlockInput.prototype, "adId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => type_graphql_1.ID, { nullable: true }),
    tslib_1.__metadata("design:type", Number)
], EmailTemplateBlockInput.prototype, "contentFeedId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Number, { nullable: true }),
    tslib_1.__metadata("design:type", Number)
], EmailTemplateBlockInput.prototype, "contentSlotNumber", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => index_1.GraphQLJSON, { nullable: true }),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateBlockInput.prototype, "contentItem", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    tslib_1.__metadata("design:type", String)
], EmailTemplateBlockInput.prototype, "contentFieldKey", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateBlockInput.prototype, "contentStr", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean, { nullable: true }),
    tslib_1.__metadata("design:type", Boolean)
], EmailTemplateBlockInput.prototype, "basicProcessing", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean, { nullable: true }),
    tslib_1.__metadata("design:type", Boolean)
], EmailTemplateBlockInput.prototype, "hidden", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean, { nullable: true }),
    tslib_1.__metadata("design:type", Boolean)
], EmailTemplateBlockInput.prototype, "hideable", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean, { nullable: true }),
    tslib_1.__metadata("design:type", Boolean)
], EmailTemplateBlockInput.prototype, "locked", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean, { nullable: true }),
    tslib_1.__metadata("design:type", Boolean)
], EmailTemplateBlockInput.prototype, "lockable", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [String], { nullable: true }),
    tslib_1.__metadata("design:type", Array)
], EmailTemplateBlockInput.prototype, "selectedTargets", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [String], { nullable: true }),
    tslib_1.__metadata("design:type", Array)
], EmailTemplateBlockInput.prototype, "attrKeys", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => index_1.GraphQLJSON, { nullable: true }),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateBlockInput.prototype, "attrs", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    class_validator_1.IsIn(index_1.BLOCK_TYPES),
    tslib_1.__metadata("design:type", String)
], EmailTemplateBlockInput.prototype, "type", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    class_validator_1.IsIn(index_1.FIELD_TYPES),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateBlockInput.prototype, "fieldType", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateBlockInput.prototype, "datetimeFormat", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [type_graphql_1.ID], { nullable: true }),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateBlockInput.prototype, "adContextIds", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    tslib_1.__metadata("design:type", String)
], EmailTemplateBlockInput.prototype, "socialProvider", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean, { nullable: true }),
    tslib_1.__metadata("design:type", Boolean)
], EmailTemplateBlockInput.prototype, "usingRichContentEditor", void 0);
EmailTemplateBlockInput = EmailTemplateBlockInput_1 = tslib_1.__decorate([
    type_graphql_1.InputType()
], EmailTemplateBlockInput);
exports.EmailTemplateBlockInput = EmailTemplateBlockInput;
// import { IContentItem, SocialProvider } from '@osmosys/types';
// import {
//   BLOCK_TYPES,
//   EmailTemplateBlockFieldType,
//   EmailTemplateBlockType,
//   FIELD_TYPES,
//   GraphQLJSON,
// } from '../index';
// import { IsIn } from 'class-validator';
// import { Field, Float, ID, InputType } from 'type-graphql';
// @InputType()
// export class EmailTemplateBlockInput {
//   @Field(() => ID, { nullable: true })
//   public id?: number;
//   @Field(() => Float, { nullable: false })
//   public order: number | undefined | null;
//   @Field(() => String, { nullable: true })
//   public name?: string;
//   @Field(() => ID, { nullable: true })
//   public cloneOfId?: number;
//   @Field(() => [EmailTemplateBlockInput], { nullable: true })
//   public childBlocks: EmailTemplateBlockInput[];
//   @Field(() => ID, { nullable: true })
//   public repeatOfId?: number;
//   @Field(() => ID, { nullable: true })
//   public parentBlockId?: number;
//   @Field(() => String, { nullable: true })
//   public clientId?: string | null | undefined;
//   @Field(() => ID, { nullable: true })
//   public adId?: number;
//   @Field(() => ID, { nullable: true })
//   public contentFeedId?: number;
//   @Field(() => Number, { nullable: true })
//   public contentSlotNumber?: number;
//   @Field(() => GraphQLJSON, { nullable: true })
//   public contentItem?: IContentItem | null;
//   @Field(() => String, { nullable: true })
//   public contentFieldKey?: string;
//   @Field(() => String, { nullable: true })
//   public contentStr?: string | null;
//   @Field(() => Boolean, { nullable: true })
//   public basicProcessing?: boolean;
//   @Field(() => Boolean, { nullable: true })
//   public hidden?: boolean;
//   @Field(() => Boolean, { nullable: true })
//   public hideable?: boolean;
//   @Field(() => Boolean, { nullable: true })
//   public locked?: boolean;
//   @Field(() => Boolean, { nullable: true })
//   public lockable?: boolean;
//   @Field(() => [String], { nullable: true })
//   public selectedTargets: string[];
//   @Field(() => [String], { nullable: true })
//   public attrKeys: string[];
//   @Field(() => GraphQLJSON, { nullable: true })
//   public attrs: { [key: string]: string };
//   @Field(() => String, { nullable: true })
//   @IsIn(BLOCK_TYPES)
//   public type: EmailTemplateBlockType;
//   @Field(() => String, { nullable: true })
//   @IsIn(FIELD_TYPES)
//   public fieldType?: EmailTemplateBlockFieldType;
//   @Field(() => String, { nullable: true })
//   public datetimeFormat?: string | null | undefined;
// }
//# sourceMappingURL=EmailTemplateBlockInput.js.map